<div>
  <!--begin::Profile Personal Information-->
  <div class="d-flex flex-row">
    <!--begin::Aside-->
    <div
      class="flex-row-auto offcanvas-mobile w-250px w-xxl-300px"
      style="min-height: 700px"
      id="kt_profile_aside"
      *ngIf="affiliation?.id"
    >
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_1">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::User-->
          <div class="d-flex align-items-center mb-5">
            <div>
              <a class="font-weight-bolder font-size-h4 text-dark-75"> {{ affiliation?.name }} </a>
              <br />
              <a class="text-muted text-hover-primary">{{
                affiliation ? affiliation.affiliation_type_name : ''
              }}</a>
            </div>
          </div>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="py-3" style="padding-left: 1.5rem">
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              [matTooltip]="affiliation ? affiliation.email : ''"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-black-back-closed-envelope-shape" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary ellipsis">{{
                affiliation ? affiliation.email : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Phone Number"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-phone" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary">{{
                affiliation ? (affiliation.phone | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Fax Number"
            >
              <span class="font-weight-bold mr-2">
                <i class="flaticon2-fax icon-md" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary">{{
                affiliation ? (affiliation.fax | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
          </div>
          <!--end::Contact-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_2">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::Nav-->
          <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
            <ng-container
              *ngFor="let tab of tabs"
              [ngTemplateOutlet]="navi_item"
              [ngTemplateOutletContext]="{ tab: tab }"
            ></ng-container>
            <ng-template #navi_item let-tab="tab">
              <div *ngxPermissionsOnly="tab.permission" class="navi-item mb-2 clickable">
                <a
                  class="navi-link py-4"
                  [ngClass]="{ active: tab.active }"
                  (click)="changeTab(tab.index)"
                >
                  <span class="navi-icon mr-2">
                    <i class="{{ tab.icon }}"></i>
                  </span>
                  <span class="navi-text font-size-lg">{{ tab.label }}</span>
                </a>
              </div>
            </ng-template>
          </div>
          <!--end::Nav-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
    </div>
    <!--end::Aside-->
    <!--begin::Content-->
    <div
      class="flex-row-fluid"
      [ngStyle]="affiliation?.id ? { 'margin-left': '8px' } : { 'margin-left': '0' }"
      style="min-height: 1050px"
    >
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[0].active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start flex-column">
            <h3 class="card-label font-weight-bolder text-dark">
              {{
                affiliation?.id
                  ? affiliation?.name + '’s Affiliation Information'
                  : 'New
              Affiliation'
              }}
            </h3>
            <span class="text-muted font-weight-bold font-size-sm mt-1"
              >{{ affiliation?.id ? 'Update ' : 'Add ' }} affiliation information</span
            >
          </div>
          <div class="card-toolbar">
            <a
              (click)="goBack()"
              class="btn btn-secondary mr-2"
              mat-raised-button
              matTooltip="{{ 'AUTH.INPUT.BACK' | translate }}"
            >
              <i class="la la-arrow-left"></i>
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.BACK' | translate }}</span>
            </a>
            <ng-template ngxPermissionsOnly="canEditAffiliation">
              <a
                *ngIf="view"
                (click)="editAffiliation(affiliation)"
                class="btn btn-secondary mr-2"
                mat-raised-button
                matTooltip="Back to the drugs list"
              >
                <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
              </a>
            </ng-template>
            <a
              *ngIf="affiliation && !affiliation.id"
              class="btn btn-secondary mr-2"
              (click)="reset()"
              [disabled]="selectedTab !== 0"
              mat-raised-button
              matTooltip="{{ 'AUTH.RESET.BUTTON' | translate }}"
            >
              <i class="la la-cog"></i>
              <span class="hidden-mobile">{{ 'AUTH.RESET.BUTTON' | translate }}</span>
            </a>
            <a
              *ngIf="!view"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="onSubmit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.SAVE' | translate }}</span>
            </a>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Form-->
        <form class="form" [formGroup]="affiliationForm" *ngIf="loadingData">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose($event)"
          >
            <ul>
              <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
            </ul>
          </kt-alert>
          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <h5 class="font-weight-bold mb-6">Affiliation Demographics</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'AFFILIATION.INPUT.NAME' | translate }}</mat-label>
                  <input matInput formControlName="name" required />
                  <mat-error *ngIf="isControlHasError('name', 'required')">
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  #affiliationTypeAutocomplete
                  [dataPath]="'data'"
                  [label]="'AFFILIATION.INPUT.AFFILIATION_TYPE' | translate"
                  [loadItemsFunction]="getAffiliationTypeAutocomplete"
                  [optionFormatter]="formatAffiliationTypeOption"
                  [valueFormatter]="formatAffiliationTypeOption"
                  [change]="handleAffiliationTypeChange.bind(this)"
                  [control]="affiliationTypeAutocomplete"
                  [required]="true"
                  [readOnly]="view"
                ></kt-general-autocomplete>
              </div>
              <ng-template ngxPermissionsOnly="canToggleSupervisingControl">
                <div class="col-lg-4 kt-margin-bottom-20-mobile">
                  <div class="mat-form-field-fluid">
                    <mat-label class="row ml-1">{{
                      'AFFILIATION.INPUT.SUPERVISING_CONTROL' | translate
                    }}</mat-label>
                    <mat-slide-toggle formControlName="supervising_control"> </mat-slide-toggle>
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mt-10 mb-6">Contact Information</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'AFFILIATION.INPUT.PHONE' | translate }}</mat-label>
                  <input matInput formControlName="phone" maxlength="14" ktAppPhoneMask />
                  <mat-error
                    >{{ 'AFFILIATION.INPUT.PHONE' | translate }}
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('phone', 'pattern')">
                    {{ 'AUTH.VALIDATION.PATTERN' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'AFFILIATION.INPUT.EMAIL' | translate }}</mat-label>
                  <input type="email" matInput formControlName="email" required />
                  <mat-error *ngIf="isControlHasError('email', 'email')">
                    {{ 'AUTH.EMAIL' | translate }}
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('email', 'required')">
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'AFFILIATION.INPUT.FAX' | translate }}</mat-label>
                  <input matInput formControlName="fax" maxlength="14" ktAppPhoneMask />
                  <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                    {{ 'AUTH.VALIDATION.PATTERN' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Office Number</mat-label>
                  <input
                    matInput
                    placeholder="Enter Office Number"
                    ktAppPhoneMask
                    formControlName="office_number"
                    autocomplete="kt-patient-office-number"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Extension</mat-label>
                  <input
                    matInput
                    placeholder="Enter Extension"
                    maxlength="7"
                    formControlName="extension"
                    autocomplete="kt-patient-extension"
                  />
                  <mat-hint><strong>Must be less than 7 digit</strong></mat-hint>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mt-10 mb-6">Address</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="urbanization"
                    [ngModel]="urbanizationValue"
                    (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
                  <input
                    matInput
                    formControlName="address_1"
                    [ngModel]="Address1Value"
                    (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('address_1', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('address_1', 'required')">
                    Address1 is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
                  <input
                    matInput
                    formControlName="address_2"
                    [ngModel]="Address2Value"
                    (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('address_2', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    [ngModel]="cityValue"
                    (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                    Maximum length is 30 character
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('city', 'required')">
                    City is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
                  <mat-select formControlName="state" required>
                    <mat-option value="AL">AL</mat-option>
                    <mat-option value="AK">AK</mat-option>
                    <mat-option value="AR">AR</mat-option>
                    <mat-option value="AZ">AZ</mat-option>
                    <mat-option value="CA">CA</mat-option>
                    <mat-option value="CO">CO</mat-option>
                    <mat-option value="CT">CT</mat-option>
                    <mat-option value="DC">DC</mat-option>
                    <mat-option value="DE">DE</mat-option>
                    <mat-option value="FL">FL</mat-option>
                    <mat-option value="GA">GA</mat-option>
                    <mat-option value="HI">HI</mat-option>
                    <mat-option value="IA">IA</mat-option>
                    <mat-option value="ID">ID</mat-option>
                    <mat-option value="IL">IL</mat-option>
                    <mat-option value="IN">IN</mat-option>
                    <mat-option value="KS">KS</mat-option>
                    <mat-option value="KY">KY</mat-option>
                    <mat-option value="LA">LA</mat-option>
                    <mat-option value="MA">MA</mat-option>
                    <mat-option value="MD">MD</mat-option>
                    <mat-option value="ME">ME</mat-option>
                    <mat-option value="MI">MI</mat-option>
                    <mat-option value="MN">MN</mat-option>
                    <mat-option value="MO">MO</mat-option>
                    <mat-option value="MS">MS</mat-option>
                    <mat-option value="MT">MT</mat-option>
                    <mat-option value="NC">NC</mat-option>
                    <mat-option value="NE">NE</mat-option>
                    <mat-option value="NH">NH</mat-option>
                    <mat-option value="NJ">NJ</mat-option>
                    <mat-option value="NM">NM</mat-option>
                    <mat-option value="NV">NV</mat-option>
                    <mat-option value="NY">NY</mat-option>
                    <mat-option value="ND">ND</mat-option>
                    <mat-option value="OH">OH</mat-option>
                    <mat-option value="OK">OK</mat-option>
                    <mat-option value="OR">OR</mat-option>
                    <mat-option value="PA">PA</mat-option>
                    <mat-option value="PR">PR</mat-option>
                    <mat-option value="RI">RI</mat-option>
                    <mat-option value="SC">SC</mat-option>
                    <mat-option value="SD">SD</mat-option>
                    <mat-option value="TN">TN</mat-option>
                    <mat-option value="TX">TX</mat-option>
                    <mat-option value="UT">UT</mat-option>
                    <mat-option value="VT">VT</mat-option>
                    <mat-option value="VA">VA</mat-option>
                    <mat-option value="WA">WA</mat-option>
                    <mat-option value="WI">WI</mat-option>
                    <mat-option value="WV">WV</mat-option>
                    <mat-option value="WY">WY</mat-option>
                  </mat-select>
                  <mat-error *ngIf="isControlHasError('state', 'required')">
                    State is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
                  <input
                    matInput
                    formControlName="zip"
                    maxlength="10"
                    [ngModel]="zipValue"
                    (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                    required
                  />
                  <mat-error *ngIf="isControlHasError('zip', 'required')">
                    Zip Code is required
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                    Zip Code is invalid
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mt-10 mb-6">Other</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'AFFILIATION.INPUT.DESCRIPTION' | translate }}</mat-label>
                  <input matInput formControlName="description" />
                </mat-form-field>
              </div>
              <div class="col-lg-6 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'AFFILIATION.INPUT.NOTE' | translate }}</mat-label>
                  <input matInput formControlName="note" />
                </mat-form-field>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </form>
        <!--end::Form-->
      </div>
      <div class="card card-custom card-stretch" *ngIf="tabs[1]?.active">
        <div class="until-they">
          <kt-affiliation-relation-list
            [isViewMode]="view"
            [entityType]="'AFFILIATION_GROUP'"
          ></kt-affiliation-relation-list>
        </div>
      </div>
    </div>
    <!--end::Content-->
  </div>
  <!--end::Profile Personal Information-->
</div>
